import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChildren,
} from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from 'src/@shared/common-pages.service';
import { ResponseStatus, ValidationMessage } from 'src/@shared/enum';
@Component({
  selector: 'add-update-site-program-period',
  templateUrl: './add-update-site-program-period.component.html',
  styleUrls: ['./add-update-site-program-period.component.scss'],

  standalone: false,
})
export class AddUpdateSiteProgramPeriodComponent implements OnInit {
  sitesData: any = [];
  isVisibleProgramPeriodDrawer = true;
  isLoadingOne: any = false;
  programPeriodDrawerTitle: any;
  @Output() hideProgramPeriodDrawer = new EventEmitter();
  @Input() selectedProgramPeriodData: any;
  @Input() selectedSiteId: any;
  validationMessage = ValidationMessage;
  selectedUnits: any[] = [];
  passwordVisible = false;
  pageSize: number = 10;
  listOfYears: any[] = [];
  listOfEndYears: any[] = [];
  listOfMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  @ViewChildren('proStartMonth') proStartMonth: any;
  @ViewChildren('proStartYear') proStartYear: any;
  @ViewChildren('proEndMonth') proEndMonth: any;
  @ViewChildren('proEndYear') proEndYear: any;
  constructor(
    public _cs: CommonService,
    private _ws: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.programPeriodForm_fb();
  }

  ngOnInit(): void {
    this.listOfYears = this.generateArrayOfYears();
    this.listOfEndYears = this.generateArrayOfYears();
    //while edit change modal title
    this.selectedProgramPeriodData != null
      ? (this.programPeriodDrawerTitle = 'Edit Program Period')
      : (this.programPeriodDrawerTitle = 'Add New Program Period');

    if (this.selectedProgramPeriodData != null) {
      this.programPeriodDrawerTitle = 'Edit Program Period';
      this._fS.programPeriodForm.patchValue({
        labelName: this.selectedProgramPeriodData.label,
        programStartMonth: this.selectedProgramPeriodData.startMonth,
        programStartYear: this.selectedProgramPeriodData.startYear,
        programEndMonth: this.selectedProgramPeriodData.endMonth,
        programEndYear: this.selectedProgramPeriodData.endYear,
        isProgramPeriodActive: this.selectedProgramPeriodData.isVisible,
      });
      if (this.selectedProgramPeriodData.isDefault) {
        this._fS.programPeriodForm.get('isProgramPeriodActive')?.disable();
      }
    } else {
      this.programPeriodDrawerTitle = 'Add New Program Period';
    }
  }
  //close drawer
  handleCancel() {
    this.isVisibleProgramPeriodDrawer = false;
    this.hideProgramPeriodDrawer.emit({
      hide: this.isVisibleProgramPeriodDrawer,
      data: null,
    });
  }
  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }
  generateArrayOfYears() {
    var max = new Date().getFullYear() + 2;
    var min = 2016;
    var years = [];

    for (var i = min; i <= max; i++) {
      years.push(i);
    }

    return years;
  }
  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.programPeriodForm.valid) {
      const formValue = this._fS.programPeriodForm.value;
      var programPeriodBody: any = {
        Id:
          this.selectedProgramPeriodData != null
            ? this.selectedProgramPeriodData.id
            : '',
        label: formValue.labelName,
        startMonth: formValue.programStartMonth,
        endMonth: formValue.programEndMonth,
        startYear: formValue.programStartYear,
        endYear: formValue.programEndYear,
        siteId: this.selectedSiteId,
        isVisible: this.selectedProgramPeriodData?.isDefault
          ? true
          : formValue.isProgramPeriodActive,
        isDefault: this.selectedProgramPeriodData
          ? this.selectedProgramPeriodData.isDefault
          : false,
        linked: this.selectedProgramPeriodData
          ? this.selectedProgramPeriodData.linked
          : 0,
      };

      if (this.selectedProgramPeriodData == null) {
        this.addProgramData(programPeriodBody);
      } else {
        this.editProgramData(programPeriodBody);
      }
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.programPeriodForm.controls).forEach(
        (control: any) => {
          if (control.invalid) {
            control.markAsDirty();
            control.updateValueAndValidity({ onlySelf: true });
          }
        }
      );
    }
  }

  editProgramData(programBody: any) {
    this.isLoadingOne = true;
    this._ws.updateProgram(programBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          // update to outer users list
          this._cs.displayMessage('success', response.message);
          //hide program drawer
          this.isLoadingOne = false;
          this.isVisibleProgramPeriodDrawer = false;
          this.hideProgramPeriodDrawer.emit({
            hide: this.isVisibleProgramPeriodDrawer,
            data: response.result,
          });
        } else {
          this.isLoadingOne = false;
          this._cs.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isLoadingOne = false;
        // this._cs.displayMessage('error', error.message);
      }
    );
  }

  addProgramData(programBody: any) {
    this.isLoadingOne = true;
    this._ws.addProgram(programBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);
          //hide unit drawer
          this.isLoadingOne = false;
          this.isVisibleProgramPeriodDrawer = false;
          this.hideProgramPeriodDrawer.emit({
            hide: this.isVisibleProgramPeriodDrawer,
            data: response.result,
          });
        } else {
          this.isLoadingOne = false;
          this._cs.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isLoadingOne = false;
        // this._cs.displayMessage('error', error.message);
      }
    );
  }
  focusProStartYear(event: any) {
    if (event) {
      this.proStartYear.first.focus();
    }
  }
  focusProEndYear(event: any) {
    if (event) {
      this.proEndYear.first.focus();
    }
  }
  onSelectStartYear(selectedYear: any) {
    if (selectedYear) {
      this.proEndMonth.first.focus();
    }
    this.listOfEndYears = this.listOfYears.filter(
      (year: any) => parseInt(year) >= parseInt(selectedYear)
    );
    this._fS.programPeriodForm.patchValue({
      programEndYear: null,
    });
  }
}
